import { exportAssetDeals as fetchExport, getAll, update } from "../api/assetDeal";

export const getAssetDeals = (assetID, status) => ({
  type: "ASSET_DEALS_GET",
  meta: { assetID },
  payload: getAll(assetID, status),
});

export const updateAssetDeal = (assetDeal) => ({
  type: "ASSET_DEAL_UPDATE",
  payload: update(assetDeal),
});

export const exportAssetDeals = (assetID) => ({
  type: "ASSET_DEAL_EXPORT",
  payload: fetchExport(assetID),
});
